import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from './adminFormat';
import authHeaders from '../authHeaders';

// Asked once per session token: the backend answers 200 only for the team's emails
// (CRM_ADMIN_EMAILS). A network or server error is not cached, so the next page asks again.
let cache = { token: null, check: null };

export function adminCheck() {
  let token = null;
  try { token = localStorage.getItem('token'); } catch { /* storage unavailable */ }
  if (!token) return Promise.resolve(false);
  if (cache.token !== token) {
    cache = {
      token,
      check: Promise.resolve()
        .then(() => axios.get(`${API}/me`, { headers: authHeaders() }))
        .then(({ data }) => data?.admin === true)
        .catch((error) => {
          const status = error?.response?.status;
          if (status !== 401 && status !== 403) cache = { token: null, check: null };
          return false;
        }),
    };
  }
  return cache.check;
}

export function resetAdminCheck() { cache = { token: null, check: null }; }

export default function useIsAdmin() {
  const [admin, setAdmin] = useState(false);
  useEffect(() => {
    let active = true;
    adminCheck().then((value) => { if (active) setAdmin(value); });
    return () => { active = false; };
  }, []);
  return admin;
}
